import { MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'isParentType'
})
export class IsParentTypePipe implements PipeTransform {

	public transform(_type: int): boolean {
		const _parentTypes: int[] = [
			MetadataAuthoringRule.AND,
			MetadataAuthoringRule.NOT,
			MetadataAuthoringRule.OR,
		];

		return _parentTypes.includes(_type);
	}

}
